<p-table [value]="deals" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="req.pageSize" #dt3
    [first]="req.page" [showCurrentPageReport]="true" [rowHover]="true" dataKey="id" lazy="true" [totalRecords]="total"
    (onLazyLoad)="loadDealsLazy($event)" [scrollable]="true" scrollHeight="flex"
    [globalFilterFields]="['customer.vatNumber', 'customer.name', 'customer.ihostid']"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

    <ng-template #caption>
        <div style="display: flex; justify-content: space-between;">
            <h3 class="m-0">Auto Renewals</h3>

            <p-iconfield iconPosition="left" class="ml-auto">
                <p-inputicon>
                    <i class="pi pi-search"></i>
                </p-inputicon>
                <input pInputText type="text" (input)="filterGlobal($event)" placeholder="Search keyword" />
            </p-iconfield>
        </div>
    </ng-template>

    <ng-template #header>
        <tr>
            <th>Deal Id</th>
            <th>iHost Id</th>
            <th>Due Date</th>
            <th>Expiration Date</th>
            <th>Parent Deal Id</th>
            <th>Notifications</th>
            <th>Amount</th>
            <th>Customer</th>
            <th>VAT</th>
            <!--<th></th>-->
        </tr>
    </ng-template>
    <ng-template #body let-deal>
        <tr>
            <td><a [href]="'/deals/edit/' + deal.crmid">{{ deal.crmid }}</a></td>
            <td>{{ deal.customer.ihostid }}</td>
            <td>{{ deal.payments[0].dueDate | date: 'dd/MM/yyyy hh:mm' }}</td>
            <td>{{ deal.subscriptionInfo?.subscriptionEndDate | date: 'dd/MM/yyyy hh:mm' }}</td>
            <td><a [href]="'/deals/edit/' + deal.parentDeal?.crmid">{{ deal?.parentDeal?.crmid }}</a></td>
            <td>
                <span *ngFor="let not of deal.notificationJobs">
                    <span>{{ not.errorMessage }}</span>
                    <p-tag
                        [severity]="(not.errorMessage != null && not.errorMessage.length > 0) ? 'danger' : (not.dateSent != null ? 'success' : 'info')"
                        class="mx-1" *ngIf="not.notificationDate != null"
                        [value]="((not.notificationDate | date: 'dd/MM/yyyy') ?? '') + ', ' + (not.type | notificationType)" /></span>
            </td>
            <td>{{ deal.value }}</td>
            <td>{{ deal.customer.name }}</td>
            <td>{{ deal.customer.vatNumber }}</td>
            <!--
            <td>
                <a [href]="'/deals/edit/' + deal.crmid">
                    <i class="pi pi-refresh" style="color: slateblue"></i>
                </a>
            </td>-->
        </tr>
    </ng-template>
</p-table>